import { TextResources } from "@portal/assets/text/TextResources";
import PortalPageBox from "@portal/components/atoms/portalPageBox";
import Typography from "@portal/components/atoms/v2/typography";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import ReloadButton from "./reloadButton";

const MissingAccess = () => (
  <PortalPageBox>
    <div className="flex flex-col justify-center items-center space-y-3">
      <div>
        <Typography variant="H6">{TextResources.NO_ACCESS_TO_FEATURE_PAGE_TITLE}</Typography>
        <TextLine />
      </div>
      <Typography variant="Body">{TextResources.NO_ACCESS_TO_FEATURE_PAGE_TEXT}</Typography>
      <div className="mt-5">
        <ReloadButton />
      </div>
    </div>
  </PortalPageBox>
);

export default MissingAccess;
